import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import HowItWorks from "@/components/landing/HowItWorks";
import Pricing from "@/components/landing/Pricing";
import Marketplace from "@/components/landing/Marketplace";
import FAQs from "@/components/landing/FAQs";
import Waitlist from "@/components/landing/Waitlist";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#FF5A00]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <HowItWorks />
        <Pricing />
        <Marketplace />
        <FAQs />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
}
